var API = {
    data: {
        dataErrors: []
    }
};

module.exports = { apiModel: API };